import Image from 'next/image'
import styled from 'styled-components'
import { ButtonSizes, TextButton } from '../../../styles/button'
import { CompaniesGridItem, CompanyCardContent, CompanyCardHeader } from '../../../styles/companies/companies'
import StyledLink from '../../global/StyledLink'
import UploadSVG from '/public/svg/img.svg'

const LogoPlaceholderContainer = styled.div`
  border-radius: 12px;
  height: 100%;
  width: 100%;
  border: none;
  background-color: ${(props) => props.theme.colors.lightBg};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
      height: 30px;
      width: 30px;
  }
`;
const BannerPlaceholderContainer = styled.div`
  border-radius: 0px;
  height: 100%;
  width: 100%;
  border: none;
  background-color: ${(props) => props.theme.colors.buttonSubtle};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;

  svg {
      height: 50px;
      width: 50px;
  }
`;

export const CompanyCard = ({ company, index, bucketUrl }) => {

    return (
        <CompaniesGridItem key={company.name}>
            <StyledLink href={'companies/' + company.slug}>
                <CompanyCardHeader className="card-media">
                    {company?.bannerUrl != null && company?.bannerUrl != "" ?
                        <Image
                            src={bucketUrl + company.bannerUrl}
                            alt="Company Card - Banner"
                            layout="fill"
                            objectFit='cover'
                            loading='eager'
                            priority
                        // width={500}
                        // height={500}
                        // blurDataURL="data:..." automatically provided
                        // placeholder="blur"
                        />
                        :
                        <BannerPlaceholderContainer>
                            <UploadSVG />
                        </BannerPlaceholderContainer>
                    }

                </CompanyCardHeader>
                <CompanyCardContent>
                    <div className='logo'>
                        {
                            company?.logoUrl != null && company?.logoUrl != "" ?
                                <Image
                                    src={bucketUrl + company.logoUrl}
                                    alt="Company Card - Logo"
                                    layout="fill"
                                    objectFit='cover'
                                    loading='eager'
                                    priority
                                // width={500}
                                // height={500}
                                // blurDataURL="data:..." automatically provided
                                // placeholder="blur"
                                />
                                :
                                <LogoPlaceholderContainer>
                                    <UploadSVG />
                                </LogoPlaceholderContainer>
                        }

                    </div>
                    <div className='company-text-content'>
                        <h1>{company.name}</h1>
                        <p>{company.teaserText}</p>
                        <TextButton primary size={ButtonSizes.s}>{"Weitere Infos >"}</TextButton>
                    </div>
                </CompanyCardContent>
            </StyledLink>
        </CompaniesGridItem>
    )
}
